import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import {
  ICreateQCResult,
  IQCFilter,
  IQCRequest,
  IQCRequestDetail,
  IQCResultByRequest,
  IQCResultDetail,
  IReEvaluateQcResult,
} from "../models/Qc";

export const qcService = {
  createQcResult: async (data: ICreateQCResult) => {
    const res = await ApiClient.POST("/qc", data);
    return res;
  },
  getQCResult: async (params: IQCFilter) => {
    const res = await ApiClient.GET("/qc", params);
    return res;
  },

  getQCRequest: async (params: IQCFilter) => {
    const res = await ApiClient.GET<IPaginatedResponse<IQCRequest>>(
      `qc-requests`,
      params,
    );
    return res;
  },
  getQCRequestDetail: async (id: number) => {
    const res = await ApiClient.GET<IQCRequestDetail>(`qc-requests/${id}`);
    return res;
  },
  acceptQCRequest: async (id: number) => {
    const res = await ApiClient.PATCH<IQCRequestDetail>(
      `qc-requests/${id}/accept`,
    );
    return res;
  },
  getQCResultDetail: async (id: number) => {
    const res = await ApiClient.GET<IQCResultDetail>(`qc/${id}`);
    return res;
  },
  reEvaluateQCResult: async (id: number, data: IReEvaluateQcResult) => {
    const res = await ApiClient.POST<IQCResultDetail>(
      `qc/${id}/re-evaluate`,
      data,
    );
    return res;
  },

  bulkEvaluateQCRequest: async (requestId: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await ApiClient.POST(
      `qc/${requestId}/bulk-evaluate`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return res;
  },
  getQCResultByRequestId: async (id: number) => {
    const res = await ApiClient.GET<IQCResultByRequest[]>(`qc/${id}/request`);
    return res;
  },
  createReturnPartNumber: async (resultIds: number[]) => {
    const res = await ApiClient.POST<number>("qc/return", {
      resultIds,
    });
    return res;
  },
  exportQcResult: async (startDate: string, endDate: string) => {
    const res = await ApiClient.GET(
      `qc/export?startDate=${startDate}&endDate=${endDate}`,
      {},
      {
        responseType: "blob",
      },
    );
    return res;
  },
};
